import { Injectable, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { DeliveryAddressService } from '@checkout-v2/feature';

export enum DeliveryState {
  Loading = 'loading',
  AddAddress = 'addAddress',
  ShowAddress = 'showAddress',
}

@Injectable()
export class DeliveryAddressBlockServiceComponent {
  private deliveryAddressService = inject(DeliveryAddressService);

  private loading = toSignal(this.deliveryAddressService.loading$, { initialValue: false });
  private hasAddress = toSignal(this.deliveryAddressService.hasActiveAddress$, { initialValue: false });

  state = computed<DeliveryState>(() => {
    if (this.loading()) return DeliveryState.Loading;
    if (!this.hasAddress()) return DeliveryState.AddAddress;

    return DeliveryState.ShowAddress;
  });
}
